/**
 * Find all duplicate elements in an array.
 *
 * Example:
 * ```
 *     findDuplicates([1, 2, 3, 1, 4, 2])
 *     => [1, 2]
 * ```
 */
function findDuplicates<T>(array: Array<T>): Array<T> {
    return array.filter((item, index) => array.indexOf(item) !== index);
}

export { findDuplicates };
